import { render, staticRenderFns } from "./orderManage.vue?vue&type=template&id=1731f070"
import script from "./orderManage.vue?vue&type=script&lang=js"
export * from "./orderManage.vue?vue&type=script&lang=js"
import style0 from "./orderManage.vue?vue&type=style&index=0&id=1731f070&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports